import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserModel, UsersService, PasswordReset } from 'src/app/Api_Module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-user-password-modal',
  templateUrl: './user-password-modal.component.html',
})
export class UserPasswordResetModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() user: UserModel;
  @Output() success: EventEmitter<any> = new EventEmitter();

  loading: boolean;
  confirmPassword: string;
  passwordMatch: boolean;

  constructor(private modalService: NgbModal, private usersService: UsersService, private toastr: ToastrService) {
  }

  ngOnInit() {
  }

  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
  }

  close(alert: any) {
    // this.alert = null;
  }
  checkPasswords() {
    this.passwordMatch = this.user.password === this.confirmPassword;
    return this.passwordMatch;
  }

  resetPassword() {
      const passwordResetReq: PasswordReset = {userId: this.user.id, password: this.user.password};
    this.usersService.reset(passwordResetReq).subscribe(()  => {
        this.loading = false;
        this.toastr.success('Password Updated!');
        this.modalService.dismissAll();
      },
        error => {
          this.loading = false;
          this.toastr.error('Something went wrong please try again later!');
          console.log('error:' + JSON.stringify(error));
        });
    }

}
